export default {
  loading: "Loading...",
  loadingLogoAlt: "Loading",
  signingIn: "Signing in...",
  signIn: "Sign in",
  signInTitle: "Sign in",
  email: "Email",
  password: "Password",
  forgotPassword: "Forgot your password?",
  recoverPassword: "Recover password",
  recoverPasswordTitle: "Recover password",
  recoverPasswordHint:
    "Enter your email and we will send you instructions to reset your password.",
  recoverPasswordSuccess:
    "We sent you a link to reset your password.",
  recoverPasswordError: "An error occurred while sending the email.",
  networkError: "A network error occurred.",
  invalidCredentials:
    "Invalid credentials. Please check your email and password.",
  loginError: "Sign-in failed. Please try again.",
  demoTitle: "Demo - Quick Access",
  createAccount: "Create Account",
  register: "Register",
  access: "Sign in",
  noAccount: "Don't have an account?",
  hasAccount: "Already have an account?",
  registerHere: "Register here",
  loginHere: "Sign in",
  confirmEmailTitle: "Confirm your email",
  confirmEmailSent: "We sent a confirmation email to:",
  confirmEmailHint:
    "Click the link in the email to activate your account and sign in.",
  confirmEmailNoLongerRequired:
    "Email confirmation is no longer required. You can sign in with your credentials.",
  backToLogin: "Back to sign in",
  confirmEmailNoReceived: "Didn't receive the email?",
  confirmEmailCheckSpam: "Check your spam or junk folder.",
  confirmEmailContactSupport: "If you still have problems, contact support.",
};
